import { Box, Skeleton } from "@mui/material";
import { Img } from "react-image";

export interface TableCellAdamObjectInfosProps {
  url: string;
}

export const TableCellAdamVignette: React.FC<TableCellAdamObjectInfosProps> = ({ url }) => {
  return (
    <Img
      src={url}
      alt={`vignette adam`}
      width={"100%"}
      height={"auto"}
      loader={<Skeleton variant="rounded" width="100%" sx={{ width: "100%", height: "100%", borderRadius: 1 }} />} // Used while loading
      unloader={<></>} // Used when image not loaded like 404
      container={(children) => {
        // <img> will be rendered as child of
        return (
          <Box width="100%" sx={{ width: "100%", maxHeight: "100%", borderRadius: 1, overflow: "hidden" }}>
            {children}
          </Box>
        );
      }}
    />
  );
};
